module.exports = __webpack_public_path__ + "img/baggage-add.903e9f40.svg";